import { generatedApi } from '@shared/api';
import { store } from '@shared/redux';
import { socket } from '../..';

export const handleFormShown = () => {
  return socket.onMessage('FORM_SHOWN', (payload) => {
    const clientId = payload.client_id;
    const messageId = payload.message_id;

    if (typeof clientId !== 'number' || typeof messageId !== 'number') return;

    const cachedArgs = generatedApi.util.selectCachedArgsForQuery(
      store.getState(),
      'getDialogHistoryDialogHistoryGet',
    );

    cachedArgs?.forEach((args) => {
      if (args.clientId !== clientId) return;

      store.dispatch(
        generatedApi.util.updateQueryData('getDialogHistoryDialogHistoryGet', args, (draft) => {
          const targetMessage = draft.items?.find((item) => item.id === messageId);

          if (!targetMessage) return;

          targetMessage.is_form_shown = true;
        }),
      );
    });
  });
};
